(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["codex-grillz-cut-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('codex-grillz-cut-selector')) {
    class CodexGrillzCutSelector extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('product-info');
        if (!this.scope) return;
        this.sync = this.syncProperties.bind(this);
        this.addEventListener('change', this.sync);
        this.scope.addEventListener('submit', this.sync, true);
        this.scope.addEventListener('click', this.syncBeforePurchase, true);
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.scope, { childList: true, subtree: true });
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('change', this.sync);
        this.scope?.removeEventListener('submit', this.sync, true);
        this.scope?.removeEventListener('click', this.syncBeforePurchase, true);
      }

      syncBeforePurchase(event) {
        if (!event.target.closest('button[type="submit"], .shopify-payment-button')) return;
        this.querySelectorAll('codex-grillz-cut-selector').forEach(selector => selector.syncProperties());
      }

      syncProperties() {
        const selected = this.querySelector('input[type="radio"]:checked');
        if (!selected || !this.scope) return;
        this.scope.querySelectorAll('input[data-grillz-cut-property]').forEach(input => {
          if (input.dataset.grillzCutProperty === this.dataset.productId && input.closest('product-info') === this.scope) {
            input.value = selected.value;
          }
        });
      }
    }
    customElements.define('codex-grillz-cut-selector', CodexGrillzCutSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snx-payment-trust-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('snx-payment-trust-card')) {
    customElements.define('snx-payment-trust-card', class extends HTMLElement {
      connectedCallback() {
        this.card = this.parentElement;
        this.grid = this.card.closest('[data-collection-products], [data-czc-grid]');
        if (!this.grid) return;
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.place());
        };
        this.itemsObserver = new MutationObserver(this.schedule);
        this.itemsObserver.observe(this.grid, { childList: true });
        this.productSelector = '[data-product-grid]:not([data-snx-payment-card]), [data-czc-category]';
        this.layoutObserver = new MutationObserver(this.schedule);
        const container = this.grid.closest('#CollectionProductsContainer');
        if (container) this.layoutObserver.observe(container, { attributes: true, attributeFilter: ['data-view'] });
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this.grid);
        const firstProduct = this.grid.querySelector(this.productSelector);
        if (firstProduct) this.resizeObserver.observe(firstProduct);
        this.schedule();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.itemsObserver?.disconnect();
        this.layoutObserver?.disconnect();
        this.resizeObserver?.disconnect();
      }

      place() {
        if (!this.isConnected) return;
        if (this.grid.querySelector('[data-snx-payment-card]') !== this.card) {
          this.card.hidden = true;
          return;
        }
        const products = Array.from(this.grid.children).filter(item => item.matches(this.productSelector) && !item.hidden);
        const firstProduct = products[0];
        if (!firstProduct) { this.card.hidden = true; return; }
        const width = firstProduct.getBoundingClientRect().width;
        if (!width) return;
        const columns = Math.max(1, Math.round(this.grid.getBoundingClientRect().width / width));
        const position = 2 * columns + (columns >= 3 ? 2 : 0);
        const nextProduct = products[position];
        if (this.card.className !== firstProduct.className) this.card.className = firstProduct.className;
        const lastProduct = products[products.length - 1];
        const productCard = (nextProduct || lastProduct).querySelector('.yv-product-card');
        if (productCard) this.style.setProperty('--snx-payment-gap', getComputedStyle(productCard).marginBottom);
        if (nextProduct) {
          if (this.card.nextElementSibling !== nextProduct) this.grid.insertBefore(this.card, nextProduct);
        } else if (lastProduct.nextElementSibling !== this.card) {
          this.grid.insertBefore(this.card, lastProduct.nextSibling);
        }
        this.card.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
